import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a]">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="eyebrow mb-6">
            <span className="gold-line" />
            Terms And Service Notes
          </div>
          <h1 className="font-heading text-4xl md:text-5xl text-white leading-[1.05]">
            Terms and Service Notes
          </h1>
          <p className="mt-6 text-[#a1a1aa]">
            Effective date: {new Date().toLocaleDateString("en-CA", { year: "numeric", month: "long" })}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 space-y-10">
          <Block title="About This Document">
            <p>
              Agent Marketing is a branded division of Kostaja Ltd. Kostaja
              Ltd. is the official company behind the Agent Marketing brand
              and is the party providing all services described on this
              website unless otherwise specified.
            </p>
          </Block>

          <Block title="No Guaranteed Leads Or Revenue">
            <p>
              Agent Marketing builds professional presence systems and
              marketing infrastructure. We do not guarantee any specific
              number of leads, appointments, closings, or revenue outcomes.
              Results depend on your market, offer, consistency, follow-up,
              and client participation.
            </p>
          </Block>

          <Block title="Client Responsibilities">
            <ul className="list-disc pl-6 space-y-2">
              <li>
                You are responsible for legal and regulatory compliance in
                your profession.
              </li>
              <li>
                MLS, brokerage, advertising, licensing, and platform rules
                remain your responsibility.
              </li>
              <li>You must supply accurate information about your business.</li>
              <li>Timelines depend on your cooperation and timely feedback.</li>
            </ul>
          </Block>

          <Block title="Payment Terms">
            <ul className="list-disc pl-6 space-y-2">
              <li>Setup fees are due before work begins unless otherwise stated.</li>
              <li>Monthly fees are billed at the start of each service period.</li>
              <li>Custom projects may require 50% upfront and 50% before launch.</li>
              <li>No final website or asset release until required payment is received.</li>
              <li>Ongoing plans require active payment status.</li>
              <li>
                Approved terms may be considered only for established agency
                accounts.
              </li>
            </ul>
          </Block>

          <Block title="Revisions And Scope">
            <p>
              Revisions are limited by the package selected. Additional
              revisions or out-of-scope work may be billed separately.
            </p>
          </Block>

          <Block title="Third-Party Costs">
            <p>
              Third-party platform fees may apply. Domain, email, software,
              advertising spend, printing, and subscription costs may be
              billed separately unless included in the package.
            </p>
          </Block>

          <Block title="Ownership And Release">
            <p>
              Final assets are released after payment. Ongoing plans must
              remain current in order to continue receiving support,
              management, and access to services.
            </p>
          </Block>

          <Block title="Cancellation">
            <p>
              Monthly service plans may be cancelled with notice as agreed at
              engagement. Setup fees and completed work are non-refundable.
              Access to managed accounts is transferred back to the client
              upon cancellation subject to any outstanding balance.
            </p>
          </Block>

          <Block title="Governing Company">
            <p>
              Agent Marketing is a branded division of Kostaja Ltd. All
              contracts, invoices, and legal notices are issued by Kostaja Ltd.
              Learn more at{" "}
              <a
                href="https://kostaja.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C8A24B] hover:underline"
              >
                kostaja.ca
              </a>
              .
            </p>
          </Block>

          <div className="pt-10 border-t border-[#27272a]">
            <Link
              to="/privacy-policy"
              className="text-sm text-[#C8A24B] hover:underline"
            >
              Read our Privacy Policy →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-heading text-2xl text-white mb-4">{title}</h2>
      <div className="text-[#d4d4d8] leading-relaxed space-y-3">{children}</div>
    </div>
  );
}
